export const HOW_YOU_WORK_TAB = 'context'
export const HOW_YOU_WORK_DETAIL_SUBTAB = 'how-you-work'

export const HOW_YOU_WORK_ROUTE = `/settings/${HOW_YOU_WORK_TAB}`
export const HOW_YOU_WORK_DETAIL_ROUTE = `${HOW_YOU_WORK_ROUTE}/${HOW_YOU_WORK_DETAIL_SUBTAB}`

export function writingStyleRoute(slug: string): string {
  return `${HOW_YOU_WORK_DETAIL_ROUTE}/${encodeURIComponent(slug)}`
}
